import { createContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";

const BusinessContext = createContext();

const BusinessContextProvider = ({ children }) => {
  const { userBusinesses } = useSelector((state) => state.business);

  const [activeBusiness, setActiveBusiness] = useState(null);

  useEffect(() => {
    if (userBusinesses?.length > 0 && activeBusiness === null) {
      setActiveBusiness(userBusinesses[0]?.id);
    }
  }, [userBusinesses, activeBusiness]);

  const [pendingRefunds, setPendingRefunds] = useState(0);

  const values = {
    activeBusiness,
    setActiveBusiness,
    pendingRefunds,
    setPendingRefunds,
  };
  return (
    <BusinessContext.Provider value={values}>
      {children}
    </BusinessContext.Provider>
  );
};

export { BusinessContext, BusinessContextProvider };
